import { webApp } from '@shared'

export function useIsMobile(): boolean {
  const isMobile =
    webApp?.platform === 'ios' ||
    webApp?.platform === 'android' ||
    webApp?.platform === 'android_x'

  return isMobile
}
